import { FC } from "react";
import { Widget } from "../../widgetList/widgetList";
import LogicalBuilderForHalalflix from "./LogicalBuilderForHalalflix";
import CustomBuilderForHalalflix from "./CustomBuilderForHalalflix";

interface Props {
  sourceType: string;
  choosenItem: Widget;
}

const LogicBuilderForHalalflix: FC<Props> = ({ sourceType, choosenItem }) => {
  return (
    <>
      {sourceType === "logical" ? (
        <LogicalBuilderForHalalflix
          sourceType={sourceType}
          choosenItem={choosenItem}
        />
      ) : sourceType === "custom" ? (
        <CustomBuilderForHalalflix sourceType={sourceType} choosenItem={choosenItem} />
      ) : null}
    </>
  );
};

export default LogicBuilderForHalalflix;
